import { Grid2, Popover, PopoverProps, Typography } from "@mui/material";
import { ReactNode } from "react";
import GKButton from "./GKButton";
import { DeleteIcon } from "./Icons";
import { Show } from "./Show";

interface Props {
  open: boolean;
  setOpen: (open: any) => void;
  anchorEl: HTMLElement | null;
  message?: string;
  onSuccess: () => void;
  modalTitle?: string;
  confirmIcon?: any;
  confirmBtnText?: string;
  minWidth?: string;
  extraComponent?: ReactNode;
}

const PopConfirm = (props: Props & PopoverProps) => {
  const {
    open,
    setOpen,
    anchorEl,
    message,
    onSuccess,
    modalTitle,
    confirmIcon,
    confirmBtnText,
    minWidth,
    anchorOrigin,
    extraComponent,
    ...rest
  } = props;

  return (
    <Popover
      {...rest}
      open={open}
      anchorEl={anchorEl}
      onClose={() => setOpen(null)}
      anchorOrigin={anchorOrigin || { vertical: "bottom", horizontal: "left" }}
      slotProps={{
        paper: {
          sx: { width: minWidth || "352px", borderRadius: "12px" },
        },
        backdrop: {
          sx: {
            backgroundColor: "rgba(0,0,0,0.2)",
            backdropFilter: "blur(2px)",
          },
        },
      }}
    >
      <Grid2 container spacing={1} p={3}>
        <Grid2 size={12}>
          <Typography fontSize={16} fontWeight={700}>
            {modalTitle || "Delete Item?"}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography fontWeight={500} color="#697586">
            {message ||
              "Are you sure you want to delete this item? All of your data will be permanently removed. This action cannot be undone."}
          </Typography>
        </Grid2>

        <Show.When isTrue={!!extraComponent}>
          <Grid2 size={12} mt={"12px"}>
            {extraComponent}
          </Grid2>
        </Show.When>

        <Grid2 size={12} mt={3} gap={1} display={"flex"}>
          <GKButton color="dark" onClick={() => setOpen(null)} fullWidth>
            Cancel
          </GKButton>
          <GKButton
            variant="lightBg"
            fullWidth
            color="error"
            onClick={() => {
              onSuccess();
              setOpen(null);
            }}
            startIcon={confirmIcon || <DeleteIcon />}
          >
            {confirmBtnText || "Yes, Delete it!"}
          </GKButton>
        </Grid2>
      </Grid2>
    </Popover>
  );
};

export default PopConfirm;
